<script>
  //IP地址
  let ip = '';

  // let httpUrl = 'http://192.168.100.102:9090/';
  let httpUrl = 'http://120.76.25.84:8200/'


  export default {
    ip,
    httpUrl
  }
</script>



// WEBPACK FOOTER //
// src/components/global.vue